// extracted by mini-css-extract-plugin
export var active = "_dn-7";
export var container = "_dn-0";
export var evenWidth = "_dn-4";
export var large = "_dn-5";
export var outlet = "_dn-8";
export var slide = "_dn-2";
export var small = "_dn-6";
export var tab = "_dn-3";
export var tabs = "_dn-1";